import { useEffect, useState, useRef } from "react";
import api, { API } from "@/lib/api";
import { Upload, Trash2, Copy } from "lucide-react";

export default function AdminMediaPage() {
  const [items, setItems] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [meta, setMeta] = useState({ alt_tr: "", title_tr: "", caption_tr: "" });
  const fileInput = useRef();

  const load = async () => { const { data } = await api.get("/admin/media"); setItems(data.items || []); };
  useEffect(() => { load(); }, []);

  const handleUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      fd.append("alt_tr", meta.alt_tr);
      fd.append("title_tr", meta.title_tr);
      fd.append("caption_tr", meta.caption_tr);
      await api.post("/admin/media/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      setMeta({ alt_tr: "", title_tr: "", caption_tr: "" });
      if (fileInput.current) fileInput.current.value = "";
      load();
    } catch (err) {
      alert("Yükleme hatası: " + (err.response?.data?.detail || err.message));
    } finally { setUploading(false); }
  };

  const del = async (id) => { if (!window.confirm("Silinsin mi?")) return; await api.delete(`/admin/media/${id}`); load(); };

  const copyUrl = (m) => {
    const url = `${API}/media/${m.id}`;
    navigator.clipboard.writeText(url);
    alert("URL kopyalandı: " + url);
  };

  return (
    <div data-testid="admin-media">
      <h1 className="font-serif text-4xl text-cc-text mb-2">Medya Kütüphanesi</h1>
      <p className="text-sm text-cc-muted mb-8">Görseller, alt text ve SEO meta yönetimi</p>

      <div className="bg-white border border-admin-border p-5 mb-8" data-testid="media-upload">
        <div className="text-[10px] tracking-overline uppercase text-cc-sepia mb-3">Yeni Görsel</div>
        <div className="grid md:grid-cols-3 gap-3 mb-3">
          <input value={meta.alt_tr} onChange={(e) => setMeta({ ...meta, alt_tr: e.target.value })} className="cc-input text-sm" placeholder="Alt text (SEO)" />
          <input value={meta.title_tr} onChange={(e) => setMeta({ ...meta, title_tr: e.target.value })} className="cc-input text-sm" placeholder="Başlık" />
          <input value={meta.caption_tr} onChange={(e) => setMeta({ ...meta, caption_tr: e.target.value })} className="cc-input text-sm" placeholder="Altyazı" />
        </div>
        <label className="cc-btn cursor-pointer inline-flex">
          <Upload size={14} />
          {uploading ? "Yükleniyor…" : "Dosya seç"}
          <input type="file" ref={fileInput} accept="image/*" onChange={handleUpload} className="hidden" data-testid="media-file" />
        </label>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {items.map((m) => (
          <div key={m.id} className="bg-white border border-admin-border overflow-hidden group">
            <div className="aspect-square bg-admin-bg overflow-hidden">
              <img src={`${API}/media/${m.id}`} alt={m.translations?.tr?.alt || ""} className="w-full h-full object-cover" />
            </div>
            <div className="p-3 text-xs">
              <div className="text-cc-text truncate" title={m.original_filename}>{m.original_filename}</div>
              <div className="text-cc-muted text-[10px] mt-1">{m.width}×{m.height}</div>
              <div className="flex gap-2 mt-2">
                <button onClick={() => copyUrl(m)} className="text-cc-muted hover:text-cc-sepia" title="URL kopyala"><Copy size={12} /></button>
                <button onClick={() => del(m.id)} className="text-cc-muted hover:text-red-600" title="Sil"><Trash2 size={12} /></button>
              </div>
            </div>
          </div>
        ))}
        {items.length === 0 && <p className="text-cc-muted text-sm col-span-full">Henüz medya yok.</p>}
      </div>
    </div>
  );
}
